import { render } from "./BaseInfoModal.vue?vue&type=template&id=349acf6e&lang=pug"
import script from "./BaseInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInfoModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__